module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-reset mb-2 text-xs"
  }, [_c('li', {
    staticClass: "flex items-center text-xs text-blue-dark pl-4 pr-2 py-2 cursor-pointer hover:bg-blue-light hover:text-white",
    on: {
      "click": function($event) {
        _vm.showSubmenu = !_vm.showSubmenu
      }
    }
  }, [_vm._t("image"), _vm._v(" "), _c('span', {
    staticClass: "mb-0 ml-2 text-sm uppercase text-blue-dark font-normal mr-auto hover:text-white"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), (_vm.showSubmenu == false) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("\n      keyboard_arrow_down\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showSubmenu == true) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("\n      keyboard_arrow_up\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubmenu),
      expression: "showSubmenu"
    }],
    staticClass: "list-reset text-sm"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be5547de","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/MenuItem.vue
// module id = 606
// module chunks = 66